import { useEffect } from 'react';
import { useSearchParams } from 'react-router';

import { onlineApi } from '@/api/online.api';
import useAppNavigate from '@/shared/hooks/useAppNavigation';
import { setDealerGroup } from '@/store/app.slice';
import { useAppDispatch } from '@/store/store';

const DEALER_GROUP_ID_KEY = 'dealerGroupId';
const REFERRER_URL_KEY = 'referrerUrl';

export const useDealerGroupInit = () => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const { navigate } = useAppNavigate();

  useEffect(() => {
    const fetchDealerGroup = async () => {
      try {
        const storedDealerGroupId = localStorage.getItem(DEALER_GROUP_ID_KEY);
        let dealerGroupId = searchParams.get('dealerGroupId');

        if (dealerGroupId && dealerGroupId !== storedDealerGroupId) {
          if (
            document.referrer &&
            !document.referrer.includes(window.location.origin)
          ) {
            localStorage.setItem(REFERRER_URL_KEY, document.referrer);
          }
          localStorage.setItem(DEALER_GROUP_ID_KEY, dealerGroupId);
        }

        if (!dealerGroupId) {
          dealerGroupId = storedDealerGroupId;
        }

        if (dealerGroupId) {
          const dealerGroup = await onlineApi.getDealerGroup(dealerGroupId);
          dispatch(setDealerGroup(dealerGroup));
        } else {
          dispatch(setDealerGroup(null));
          const referrerUrl = localStorage.getItem(REFERRER_URL_KEY);

          localStorage.removeItem(REFERRER_URL_KEY);
          localStorage.removeItem(DEALER_GROUP_ID_KEY);

          if (referrerUrl) {
            window.location.href = referrerUrl;
          } else {
            navigate('/create', { replace: true });
          }
        }
      } catch (error) {
        console.error('Failed to fetch dealer group:', error);
        dispatch(setDealerGroup(null));

        const referrerUrl = localStorage.getItem(REFERRER_URL_KEY);
        localStorage.removeItem(REFERRER_URL_KEY);
        localStorage.removeItem(DEALER_GROUP_ID_KEY);

        if (referrerUrl) {
          window.location.href = referrerUrl;
        } else {
          navigate('/create', { replace: true });
        }
      }
    };

    fetchDealerGroup();
  }, [searchParams, dispatch, navigate]);
};
